
















































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'
import SearchInput from '@/components/inputs/SearchInput.vue'
import Icon from '@/components/Icon.vue'
import Pagination from '@/components/tables/Pagination.vue'
import Confirm from '@/components/Confirm.vue'
import { FacilityModule } from '@/store/modules/facility.module'
import {
  IFacilityClaimFlowsFilters,
  IClaimFlow,
  IFacilityClaimFlowsResult,
  EUserPermissions
} from '@zunta/configurations'
import { NoCache } from '@/decorators/NoCache'

import { callIfNothingSelected } from '@/utils/helpers'
import Api from '@/api'
import { User } from '@/classes/User'
import { Debounce } from 'vue-debounce-decorator'

@Component({
  components: {
    SearchInput,
    Icon,
    Pagination,
    Confirm
  }
})
export default class ClaimFlow extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  EUserPermissions: any = EUserPermissions;
  user: User = Api.getUser() as User;
  query: IFacilityClaimFlowsFilters = {
    skip: 0,
    limit: 20
  };

  isLoading: boolean = false;
  claimFlowForDelete: number | string | null = null;

  @NoCache
  get totalFlows () {
    return this.$store.state.facility.claimFlowTableTotal
  }

  @NoCache
  get items () {
    return this.$store.state.facility.claimFlowTableItems
  }

  get facilityId () {
    return this.$route.params.id
  }

  get deleteFlowMessage () {
    const flow = this.items.find((item: IFacilityClaimFlowsResult) => {
      if (this.claimFlowForDelete) {
        return item.claimFlowId.toString() === this.claimFlowForDelete.toString()
      } else {
        return false
      }
    })
    if (flow) {
      if (flow.payerTypes.length > 0) {
        return 'Are you sure you want to delete this flow? There are Payers assigned to this flow. If you choose to delete the flow, please remember to assign a new flow.'
      } else {
        return 'Are you sure you want to delete this flow? This cannot be undone'
      }
    }
    return ''
  }

  async mounted () {
    await this.fetchItems()
    this.goEdit = callIfNothingSelected(this.goEdit.bind(this))
    this.$locationManager.rememberLocation(this.$route.fullPath)
  }

  async fetchItems () {
    this.isLoading = true
    await this.facilityModuleInstance.getFacilityClaimFlows({
        facilityId: this.facilityId,
        filters: this.query
      })
    this.isLoading = false
  }

  goEdit (claimFlowId: number | string) {
    if (this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
      this.$locationManager.rememberAndGoTo({
        name: 'management-facilities-settings-create-claim-flow',
        params: {
          facilityId: this.facilityId.toString(),
          claimFlowId: claimFlowId.toString()
        }
      })
    }
  }

  changePage (page: number) {
    if (this.query.limit) {
      this.query.skip = (page - 1) * this.query.limit
      this.fetchItems()
    }
  }

  changePageSize (size: number) {
    this.query.limit = size
    this.query.skip = 0
    this.fetchItems()
  }

  @Debounce(300)
  changeQueryField (fieldName: string, value: string) {
    if (value) {
      (this.query as any)[fieldName] = value
    } else {
      delete (this.query as any)[fieldName]
    }
    this.fetchItems()
  }

  closeDeleteConfirmation () {
    this.claimFlowForDelete = null
  }

  openDeleteConfirmation (claimFlow: number | string) {
    this.claimFlowForDelete = claimFlow
  }

  async deleteClaimFlow () {
    if (!this.user.hasPermissionFor(EUserPermissions.MODIFY_COLLECTIONS_FLOW)) {
      this.$eventBus.$emit('notify', {
        color: 'var(--status-error-color)',
        message: 'Permission Denied',
        header: 'Modify Claim Flow',
        icon: 'warning'
      })
    }
    if (this.claimFlowForDelete) {
      const response = await this.facilityModuleInstance.deleteClaimFlow(Number(this.claimFlowForDelete))
      if (response === 'OK') {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-success-color)',
          message: 'Claim Flow successfully deleted!',
          header: 'Delete Claim Flow',
          icon: 'check'
        })
      } else {
        this.$eventBus.$emit('notify', {
          color: 'var(--status-error-color)',
          message: 'Something went wrong',
          header: 'Delete Claim Flow',
          icon: 'warning'
        })
      }
      this.claimFlowForDelete = null
      this.fetchItems()
    }
  }
}
